import { IconButton, List, ListItem, ListItemButton, ListItemText, TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { CollateralTablePropsType } from "../../../types/container.type";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";

export const CollateralTable: React.FC<CollateralTablePropsType> = ({ rows, handleEllipsisButtonClick, handleActionItemClick, selectedCollateral, dropdownRef }) => {
    const actions = ["Edit", "Delete"];
    const collateralTableHeaders = ["Name", "Collateral Type", "Serial Number", "Estimated Price", "Action"];

    return (
        <BaseTable headers={collateralTableHeaders}>
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{row?.name?.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</TableCell>
                            <TableCell>{row?.type?.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</TableCell>
                            <TableCell>{row?.serialNo.toString().padStart(3, '0')}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.estimatedPrice ?? 0)}</TableCell>
                            <TableCell>
                                <IconButton
                                    sx={{
                                        borderRadius: "0.5rem",
                                        backgroundColor: "var(--sky-blue-color)",
                                        "&:hover": {
                                            backgroundColor: "var(--sky-blue-color)"
                                        }
                                    }}
                                    onClick={(e) => handleEllipsisButtonClick(e, row)}
                                >
                                    <MoreVertIcon
                                        sx={{
                                            color: "#FFFFFF",
                                            display: "inline-flex",
                                        }}
                                    />
                                </IconButton>
                                {(selectedCollateral?.id && selectedCollateral?.id === row?.id) && (
                                    <List
                                        component={"ul"}
                                        ref={dropdownRef}
                                        className="dropdown-modal"
                                    >
                                        {actions.map((action, index) => (
                                            <ListItem
                                                key={index}
                                                onClick={(e) => handleActionItemClick(e, selectedCollateral?.id, action)}
                                            >
                                                <ListItemButton>
                                                    <ListItemText
                                                        primary={action}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                    </List>
                                )}
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}
